export const generateTimeIntervals = (interval = 15) => {
	const times = [];
	let tt = 0;

	for (let i = 0; tt < 24 * 60; i++) {
		const hh = Math.floor(tt / 60);
		const mm = tt % 60;
		const v = ('0' + hh).slice(-2) + ':' + ('0' + mm).slice(-2);

		times.push(v);

		tt = tt + interval;
	}

	return times;
};
